export default {
  funnel_register_funnel: '注册漏斗',
  funnel_register_funnel_casual: '休闲游戏漏斗',
  funnel_register_funnel_pc: '注册漏斗 PC',
  funnel_register_funnel_steam: '注册漏斗 Steam',
  funnel_register_funnel_epic: '注册漏斗 Epic',
  funnel_register_funnel_ps: '注册漏斗 PS',
  funnel_register_funnel_xbox: '注册漏斗 Xbox',
  funnel_device_conversion: '设备转化率%',
  funnel_lost: '折损',
  funnel_funnel: '漏斗',
  funnel_step: '步骤',
  funnel_inevitable_step: '必经步骤',
  funnel_avg_time: '平均花费时长(s)',
  funnel_trends_by_step: '步骤趋势',
  funnel_trends: '趋势',
  funnel_overall_performance: '指标总体表现',
  funnel_app_launch: '启动游戏',
  funnel_finish_user_agreement: '同意用户协议',
  funnel_complete_updates: '完成更新',
  funnel_confirm_login_channel: '选择登录渠道',
  funnel_channel_auth_success: '完成渠道授权',
  funnel_register_success: '渠道/游客账号注册成功',
  funnel_show_enter_game: '到达开始游戏界面',
  funnel_click_into_game: '点击开始',
  funnel_enter_lobby_success: '连接大厅服成功',
  funnel_by_app_version: '分App版本',
  funnel_by_network_type: '分网络类型',
  funnel_by_memory: '分内存',
  funnel_by_store_channel: '分商店渠道',
  funnel_by_version: '分版本',
  funnel_version: '版本',
  funnel_by_game_stage: '分游戏阶段',
  funnel_game_stage: '游戏阶段',
  funnel_by_character_class: '分角色',
  funnel_character_class: '角色',
  funnel_by_user_type: '分用户标签',
  funnel_user_type: '分用户标签',
  funnel_conversion: '转化率%',
  funnel_count: '设备数',
  funnel_lost_percent: '折损%',
  funnel_device_count_conversion: '设备数&转化率%',
  funnel_total: '总体',

  funnel_funnel_expresion: '说明：由于"运营总况-日报"的新进用户数定义为首次登录大厅游戏的用户，玩家在账号注册成功到登录大厅有一定的环节有折损，因此本页面的注册成功用户数与"运营总况-日报"新进用户数略有差异。',
  funnel_funnel_app_version_expresion: "玩家的App版本",
  funnel_funnel_memory_expresion: "玩家的设备内存",
  funnel_funnel_store_channel_expresion: "玩家下载的商店渠道",
  funnel_funnel_language_expresion: "玩家注册系统语言",
  funnel_funnel_network_expresion: " 玩家的网络类型",
  funnel_funnel_app_version_all: "展示所有app版本的去重用户数据",
  funnel_funnel_memory_all_expresion: "展示所有内存的去重用户数据",
  funnel_filter_tips: "玩家的{name}",
};